import React from "react";

import { Stack, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface NumberedStepProps {
  number: number;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const NumberedStep: React.FC<NumberedStepProps> = ({ number, children, sx }) => {
  return (
    <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={sx}>
      <Stack
        sx={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          bgcolor: "primary.main",
          color: "primary.contrastText",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Trebuchet MS', 'Segoe UI', sans-serif",
          fontSize: "0.75rem",
          fontWeight: 700,
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        {number}
      </Stack>
      <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
        {children}
      </Typography>
    </Stack>
  );
};

export default NumberedStep;
